import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { DrawerKeys } from '~components/shared/drawer/drawer-manager';

export type SpecificDrawerType<T = any> = {
  drawerId: DrawerKeys;
  data?: T;
};

type InitialDrawerType = {
  stack: SpecificDrawerType[];
};

const initialState: InitialDrawerType = {
  stack: [],
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    openSpecificDrawer: (state, action) => {
      state.stack.push(action.payload);
    },
    closeSpecificDrawer: (state, action: PayloadAction<DrawerKeys>) => {
      state.stack = state.stack.filter(
        (drawer) => drawer.drawerId !== action.payload,
      );
    },
    closeAllDrawers: (state) => {
      state.stack = [];
    },
  },
});

export const { openSpecificDrawer, closeSpecificDrawer, closeAllDrawers } =
  drawerSlice.actions;

export default drawerSlice.reducer;
